import styled from "@emotion/styled";

export const RatingCard = styled.div`
    width: 100%;
    min-width: 0;
    border-radius: 10px;
    padding: 14px 16px;
    box-sizing: border-box;
`;

export const RatingLabel = styled.div`
    color: ${({ theme }) => theme.colors.text.primary};
    font-size: ${({ theme }) => theme.fontSizes.medium};
    opacity: 0.95;
    margin-bottom: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const StarsPill = styled.div`
    width: fit-content;
    max-width: 100%;
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 10px 14px;
    border-radius: 6px;
    background: rgba(41, 56, 77, 0.55);

    svg {
        width: 20px;
        height: 20px;
    }
`;
